import { SectionLabel, PrimaryButton } from "@/components/Bits";
import { GraduationCap, Building2, TrendingUp, Check } from "lucide-react";

const IMG_INFRA =
  "https://images.unsplash.com/photo-1651503773635-d989bab7b519?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBzcG9ydHMlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzgyMDM3NDcwfDA&ixlib=rb-4.1.0&q=85";

const services = [
  {
    icon: GraduationCap,
    title: "Education",
    index: "01",
    lead: "Raising the standard of knowledge across sport.",
    items: [
      "Higher Education, CPD and Accreditation Support",
      "Sports Literacy for clubs and communities",
      "Workshops, curricula and learning programs",
      "Knowledge transfer between elite and grassroots",
    ],
  },
  {
    icon: Building2,
    title: "Infrastructure",
    index: "02",
    lead: "Building the foundations sport needs to grow.",
    items: [
      "Facility planning & development advisory",
      "Systems, processes and operational frameworks",
      "Technology and data infrastructure",
      "Sustainable, scalable foundations",
    ],
  },
  {
    icon: TrendingUp,
    title: "Development",
    index: "03",
    lead: "Turning potential into lasting performance.",
    items: [
      "Athlete & talent pathway design",
      "People and workforce development",
      "Programme delivery and mentoring",
      "Long-term progress measurement",
    ],
  },
];

export default function Services() {
  return (
    <div className="bg-white">
      {/* HERO */}
      <section className="border-b border-[#E5E5E5]">
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-20 md:py-28">
          <SectionLabel index="01">What we do</SectionLabel>
          <h1 className="mt-8 max-w-4xl font-heading font-bold uppercase leading-[0.95] tracking-tighter text-[#111111] text-5xl md:text-7xl">
            Three pillars. One mission.
          </h1>
          <p className="mt-8 max-w-2xl text-[#333333] text-base md:text-lg leading-relaxed">
            Everything we do feeds the wheel. Each service strengthens the next, compounding into
            real, measurable change across the sporting world.
          </p>
        </div>
      </section>

      {/* SERVICE BLOCKS */}
      <section className="mx-auto max-w-7xl px-6 md:px-10 py-20 md:py-28 space-y-px">
        {services.map((s, i) => (
          <div
            key={s.title}
            data-testid={`service-${s.title.toLowerCase()}`}
            className="grid gap-10 border-t border-[#E5E5E5] py-14 lg:grid-cols-12"
          >
            <div className="lg:col-span-4">
              <div className="flex items-center gap-4">
                <s.icon size={36} strokeWidth={1.5} className="text-[#111111]" />
                <span className="font-heading text-sm tracking-[0.3em] text-[#777777]">{s.index}</span>
              </div>
              <h2 className="mt-6 font-heading font-bold uppercase tracking-tight text-[#111111] text-4xl md:text-5xl">
                {s.title}
              </h2>
              <p className="mt-4 text-[#333333] leading-relaxed">{s.lead}</p>
            </div>
            <div className="lg:col-span-8 lg:border-l lg:border-[#E5E5E5] lg:pl-12">
              <ul className="grid gap-5 sm:grid-cols-2">
                {s.items.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center bg-[#111111]">
                      <Check size={14} className="text-white" />
                    </span>
                    <span className="text-[#333333] leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </section>

      {/* IMAGE CTA */}
      <section className="relative overflow-hidden bg-[#111111] border-t border-[#E5E5E5]">
        <img
          src={IMG_INFRA}
          alt="Infrastructure"
          className="absolute inset-0 h-full w-full object-cover opacity-20 grayscale"
        />
        <div className="relative mx-auto max-w-7xl px-6 md:px-10 py-24 text-center">
          <h2 className="font-heading font-bold uppercase tracking-tight text-white text-3xl md:text-5xl">
            Tell us where you want to go
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-[#E5E5E5] leading-relaxed">
            We tailor every engagement to the people and the goal. Start the conversation.
          </p>
          <div className="mt-10 flex justify-center">
            <PrimaryButton to="/contact" testid="services-cta">Get in touch</PrimaryButton>
          </div>
        </div>
      </section>
    </div>
  );
}
